export default {
    LOCKED: 'locked',
    UNLOCKED: 'unlocked',
    BLOCKED: 'blocked',
    FAIL: 'fail'
};
